import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In production, this would send to your backend
    console.log('Contact form submitted:', formData);
    setSubmitted(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setFormData({ name: '', email: '', subject: '', message: '' });
      setSubmitted(false);
    }, 3000);
  };

  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="back-link">← Back to Home</Link>
        
        <h1>Contact Us</h1>
        <p className="subtitle">We're here to help! Reach out to us through any of the following channels.</p>

        <div className="contact-grid">
          <div className="contact-methods">
            <h2>Get In Touch</h2>
            
            <div className="contact-method">
              <div className="contact-icon">📧</div>
              <div>
                <h3>Email Support</h3>
                <p><a href="mailto:support@kwikluv.com">support@kwikluv.com</a></p>
                <p className="response-time">Response time: 24-48 hours</p>
              </div>
            </div>

            <div className="contact-method">
              <div className="contact-icon">💬</div>
              <div>
                <h3>WhatsApp</h3>
                <p><a href="https://wa.me/27123456789" target="_blank" rel="noopener noreferrer">+27 12 345 6789</a></p>
                <p className="response-time">Available: Mon-Fri, 9AM-5PM SAST</p>
              </div>
            </div>

            <div className="contact-method">
              <div className="contact-icon">📍</div>
              <div>
                <h3>Mailing Address</h3>
                <p>
                  KwikLuv<br />
                  P.O. Box 12345<br />
                  Johannesburg, 2000<br />
                  South Africa
                </p>
              </div>
            </div>

            <div className="contact-method">
              <div className="contact-icon">⚖️</div>
              <div>
                <h3>Legal Inquiries</h3>
                <p><a href="mailto:legal@kwikluv.com">legal@kwikluv.com</a></p>
              </div>
            </div>

            <div className="contact-method">
              <div className="contact-icon">🔒</div>
              <div>
                <h3>Privacy & Data</h3>
                <p><a href="mailto:privacy@kwikluv.com">privacy@kwikluv.com</a></p>
              </div>
            </div>
          </div>

          <div className="contact-form-section">
            <h2>Send Us a Message</h2>
            
            {submitted ? (
              <div className="success-message">
                <div className="success-icon">✓</div>
                <h3>Message Sent!</h3>
                <p>Thank you for contacting us. We'll get back to you within 24-48 hours.</p>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Your name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your@email.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select a subject</option>
                    <option value="general">General Inquiry</option>
                    <option value="support">Technical Support</option>
                    <option value="billing">Billing Question</option>
                    <option value="report">Report Abuse</option>
                    <option value="verification">Verification Issue</option>
                    <option value="account">Account Problem</option>
                    <option value="feedback">Feedback</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Tell us how we can help..."
                  />
                </div>

                <button type="submit" className="submit-btn">
                  Send Message
                </button>
              </form>
            )}
          </div>
        </div>

        <section className="faq-preview">
          <h2>Frequently Asked Questions</h2>
          <p>Looking for quick answers? Check out our <Link to="/faq">FAQ page</Link> for common questions.</p>
        </section>
      </div>
    </div>
  );
};

export default Contact;
